// Validaciones de formularios (cliente). Mensajes en español, listos para
// mostrar inline. Mantener simple: solo lo que el backend también valida.

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function isValidUrl(value: string): boolean {
  const v = value.trim();
  if (!v) return true; // vacío = válido (campo opcional)
  try {
    const u = new URL(v);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

/** Clase para el borde del input cuando hay error. */
export function inputClass(hasError: boolean): string {
  return hasError ? 'input border-red-500 focus:ring-red-500' : 'input';
}
